import React from 'react';
import { CalculatorIcon, SearchIcon, WrenchIcon, HeartIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Get Instant Quote',
    description: 'Tell us about your roof and get a transparent quote in minutes.',
    icon: <CalculatorIcon className="h-8 w-8 text-amber-500" data-id="element-213" />
  }, {
    number: '2',
    title: 'Free Inspection',
    description: 'Our certified team inspects your roof at no cost or obligation.',
    icon: <SearchIcon className="h-8 w-8 text-amber-500" data-id="element-214" />
  }, {
    number: '3',
    title: 'We Handle Everything',
    description: 'From permits to cleanup, we manage every detail.',
    icon: <WrenchIcon className="h-8 w-8 text-amber-500" data-id="element-215" />
  }, {
    number: '4',
    title: 'Love Your New Roof',
    description: 'Enjoy peace of mind with our lifetime workmanship warranty.',
    icon: <HeartIcon className="h-8 w-8 text-amber-500" data-id="element-216" />
  }];
  return <section className="py-16 md:py-24 bg-slate-50" data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-218">
        <div className="text-center mb-16" data-id="element-219">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4" data-id="element-220">
            Roofing Made Simple
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto" data-id="element-221">
            Our streamlined process ensures a stress-free experience from start
            to finish.
          </p>
        </div>

        <div className="relative" data-id="element-222">
          {/* Connecting Line (Desktop Only) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-amber-200 z-0" data-id="element-223"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative z-10" data-id="element-224">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-225">
                <div className="w-24 h-24 bg-white rounded-full flex items-center justify-center border-4 border-amber-100 shadow-lg mb-6 relative" data-id="element-226">
                  <div className="absolute -top-3 -right-3 w-8 h-8 bg-amber-500 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md" data-id="element-227">
                    {step.number}
                  </div>
                  {step.icon}
                </div>
                <h3 className="text-xl font-bold text-foreground mb-3" data-id="element-228">
                  {step.title}
                </h3>
                <p className="text-muted-foreground" data-id="element-229">{step.description}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}